import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from './../actions/user_actions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { validate } from '../validations';
import InputMask from 'react-input-mask';
import * as SettingActions from '../actions/settingScreen_actions';
import { ModalDialogCommon } from '../components/modal_dialog_common';
import Modal from 'react-modal';
import Dropzone from 'react-dropzone';
import * as FacilitiesActions from '../actions/facilities_actions';
import * as serviceCallConfig from '../config/api_urls';

let Registration = React.createClass({
    getInitialState() {
        return {
            // Default vlaues Start
            selectedTab: 0,
            registrationUrlDetails: null,

            highestDegrees: null,
            professionalRoles: null,
            ethnicities: null,

            showError: null,
            errorMessage: 'Please enter necessary fields to proceed. ',

            roleId: null,
            firstName: null,
            lastName: null,
            mobile: null,
            email: null,
            dobYear: null,
            dobMonth: null,
            highestDegreeId: null,
            professionalRoleID: null,
            gender: "",

            ethnicity: null,
            ethnicityId: null,
            otherEthnicity: null,
            facilityRoleId: null,
            imageUrl: null,

            userName: null,
            password: null,

            mobileCssClass: "inputText",

            showOkModel: false,
            oKModelMessage: null,
            updatedProfileImageName: null,

            isUpdateRegistrationSuccess: null,

            confimationModalMessage: null,
            isRegistrationLinkExpired: null, facilityId: null,
            // Default vlaues End



            // /// rough data for Testing neeed to delete -- Start
            // selectedTab: 0,
            // registrationUrlDetails: null,

            // highestDegrees: null,
            // professionalRoles: null,
            // ethnicities: null,

            // showError: null,
            // errorMessage: 'Please enter necessary fields to proceed. ',

            // roleId: null,
            // firstName: 'Raju',
            // lastName: 'Ch',
            // mobile: '9666689355',
            // email: 'raju@g.com',
            // dobYear: '2015',
            // dobMonth: '3',
            // highestDegreeId: '3',
            // professionalRoleID: 5,
            // gender: "MALE",

            // ethnicityId: null,
            // otherEthnicity: null,
            // facilityRoleId: null,
            // imageUrl: null,

            // userName: null,
            // password: null,

            // mobileCssClass: "inputText",

            // showOkModel: false,
            // oKModelMessage: null,
            // updatedProfileImageName: null,

            // isUpdateRegistrationSuccess: null,
            // /// rough data neeed to delete -- End
        }
    },
    componentWillReceiveProps(nextProps) {

        if (!nextProps.SessionLogoutResponse) {
            this.setState({ highestDegrees: nextProps.RegistrationDetails.highestDegrees.data });
            this.setState({ professionalRoles: nextProps.RegistrationDetails.professionalRoles.data });
            this.setState({ ethnicities: nextProps.RegistrationDetails.ethnicities.data });
        }



        if (nextProps.Settings.profileUpdate && nextProps.Settings.profileUpdate.status == 200) {
            this.setState({ isUpdateRegistrationSuccess: true, showOkModel: true, oKModelMessage: "All done! Now you can log in to your new MOBI account" });

        } else {
            if (nextProps.Settings.profileUpdate && nextProps.Settings.profileUpdate.status !== 200) {
                this.setState({
                    isUpdateRegistrationSuccess: null,
                    showOkModel: true,
                    oKModelMessage: nextProps.Settings.profileUpdate.message
                })
            }
        }


        if (nextProps.FacilitiesDetails.FacilityImageUpload && nextProps.FacilitiesDetails.FacilityImageUpload.status == 200) {
            nextProps.FacilitiesDetails.FacilityImageUpload ? this.setState({ imageUrl: nextProps.FacilitiesDetails.FacilityImageUpload.data }) : this.setState({ imageUrl: null });
        }

        if (nextProps.SessionLogoutResponse) {
            if (nextProps.SessionLogoutResponse.status == 200) {
                this.setState({ confimationModalMessage: null });
                this.props.Dispatch(UserActions.user_log_out());
                localStorage.clear();
                if (this.state.isUpdateRegistrationSuccess) {
                    this.props.router.push('/');
                } else {
                    this.getDataToRegister();
                }
            } else {
                // need to show error msg from server response
            }
        }
    },

    componentDidMount() {

    },

    componentWillMount() {

        // Registration URL parsing.
        function getParameterByName(name, url) {

            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
        var token = getParameterByName('token', window.location.href);
        var urlData = token.split('#')

        //if Link was already expired.
        if (urlData[5].indexOf('!') > 0) {
            urlData[5] = urlData[5].substring(0, urlData[5].indexOf('!'));
        }
        var currentTimeStamp = new Date().getTime();
        if (currentTimeStamp > urlData[5]) {
            this.setState({ showOkModel: true, oKModelMessage: 'The registration link has expired. Please consult Admin to complete registration.', isRegistrationLinkExpired: true })
            return
        }

        console.log(urlData, 'urlData');
        

        this.setState({
            registrationUrlDetails: {
                'roleId': urlData[0],
                'email': urlData[1],
                'mobile': urlData[2],
                'uniqueKey': urlData[3],
                'userId': urlData[4],
                'timeStamp': urlData[5],
                'facilityId': urlData[6]
            }
        });

        // redirection to login page, if another user session already exists.
        if (this.props.RegistrationDetails && this.props.RegistrationDetails.loginData && this.props.RegistrationDetails.loginData.status === 200) {
            this.setState({ confimationModalMessage: 'You need to logout the current session to register a new account.' });
            return;
        }

        this.getDataToRegister();
    },

    getDataToRegister() {
        this.props.Dispatch(UserActions.highestDegrees());
        this.props.Dispatch(UserActions.professionalRoles());
        this.props.Dispatch(UserActions.ethnicities());
    },

    onConfirmed() {
        this.props.Dispatch(UserActions.logout(
            {
                "appType": "WEB",
                "id": this.props.RegistrationDetails.loginData.data.id
            }
        ));
        // this.props.Dispatch(UserActions.user_log_out());
        // this.getDataToRegister();
        //this.setState({ confimationModalMessage: null });
    },
    closeConfirmationModal() {
        this.setState({ confimationModalMessage: null });
        this.props.router.push('/');
    },
    monthsData() {
        //this.setState({ HigestDegree: HigestDegreeData.data });


    },
    yearofBirth() {
        // var year = _.range(1970, 2017);
        // this.setState({ Years: year });
    },

    onBackTabSubmitted(e) {
        this.setState({
            showError: null,
            errorMessage: null,
        })
        this.setState({ selectedTab: parseInt(e.target.dataset.backindex) - 1 });
    },

    onTabSubmitted(e) {

        if (e.target.value == 1) {
            if (this.isValideUserDetails()) {
                this.setState({ selectedTab: parseInt(e.target.value) });
                return;
            }
            else {
                return;
            }
        }

        if (e.target.value == 2) {
            if (this.isValideUserEthnicityFacilityDetails()) {
                this.setState({ selectedTab: parseInt(e.target.value) });
                return;
            }
            else {
                return;
            }
        }

        if (e.target.value == 3) {
            if (this.isValidTC()) {
                this.setState({ selectedTab: parseInt(e.target.value) });
                return;
            }
            else {
                return;
            }
        }

        if (e.target.value == 4) {
            if (this.isValideUserNamePasswordDetails()) {

                var data = {
                    "id": this.state.registrationUrlDetails.userId,
                    "uniqueKey": this.state.registrationUrlDetails.uniqueKey,
                    "firstName": this.state.firstName,
                    "lastName": this.state.lastName,
                    "userName": this.state.userName,
                    "password": this.state.password,
                    "mobile": this.state.registrationUrlDetails.mobile,
                    "email": this.state.registrationUrlDetails.email,
                    "gender": this.state.gender,
                    "qualification": { "id": this.state.highestDegreeId },
                    "role": { "id": this.state.registrationUrlDetails.roleId },
                    "facility": { "id": this.state.registrationUrlDetails.facilityId },
                    //"facilityRole": { "id": this.state.facilityRoleId },
                    "ethnicity": this.state.ethnicityId !== '7' ? this.state.ethnicity : this.state.otherEthnicity,
                    "yearOfDob": this.state.dobYear,
                    "monthOfDob": this.state.dobMonth,
                    "imageUrl": this.state.imageUrl,
                }

                if(this.state.professionalRoleID){
                    data['professionalRole'] = { "id": this.state.professionalRoleID };
                }

                if (this.state.registrationUrlDetails.roleId === '2' ) {
                    data.facilityRole = { "id": this.state.facilityRoleId };
                }

                this.props.Dispatch(SettingActions.registrationProfileUpdate(data));
                // return;
            }
            else {
                //return;
            }

        }
    },

    remove_error(event) {
        event.target.className = 'inputText';
    },

    no_empty(event) {
        event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    email_validate(event) {
        validate.email(event.target.value) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    phon_validate(event) {
        let mobile = event.target.value;
        let isValidMobile = validate.phone(mobile);

        let isExpectedMobile = false;
        if ((event.target.value.trim().length > 0) && (this.state.registrationUrlDetails.mobile.replace(/ /g, "") != event.target.value.replace(/ /g, ""))) {
            this.setState({
                showError: true,
                errorMessage: "Entered mobile number should match with registered mobile number."
            })
        }
        else {
            isExpectedMobile = true;
            // To show generic message if User doesn't enter any value.
            if (this.state.errorMessage != 'Please enter necessary fields to proceed. ') {
                this.setState({
                    showError: null,
                    errorMessage: null,
                })
            }
        }
        isValidMobile && isExpectedMobile ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    selectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
    },

    remove_selection_error(event) {
        event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown'
    },

    genderSelected(event) {
        event.target.parentElement.className = 'admin-register-button'
        this.setState({ gender: event.target.value });
        for (let i = 0; i < event.target.parentElement.children.length; i++) {
            event.target.parentElement.children[i].className = 'white-button'
        }
        event.target.className = 'white-button active'
    },


    isValideUserDetails() {



        let isValidFName = validate.name(this.refs.firstName);
        isValidFName ? this.refs.firstName.className = 'inputText' : this.refs.firstName.className = 'inputText error';

        let isValidLName = validate.name(this.refs.lastName);
        isValidLName ? this.refs.lastName.className = 'inputText' : this.refs.lastName.className = 'inputText error';

        // Mobile Validation
        let isValidMobile = validate.phone(this.refs.mobile.state.value);
        let isExpectedMobile = false;
        let enteredMobile = this.refs.mobile.state.value.replace(/ /g, "");
        if (this.state.registrationUrlDetails.mobile.replace(/ /g, "") != enteredMobile) {
            this.setState({
                showError: true,
                errorMessage: "Entered mobile number should match with registered mobile number."
            })
        }
        else {
            isExpectedMobile = true;
            this.setState({
                showError: true,
                errorMessage: "Please enter necessary fields to proceed. "
            })
        }
        isValidMobile && isExpectedMobile ? this.setState({ mobileCssClass: 'inputText' }) : this.setState({ mobileCssClass: 'inputText error' });

        let isValidEmail = validate.email(this.refs.email.value);
        isValidEmail ? this.refs.email.className = 'inputText' : this.refs.email.className = 'inputText error';

        // validation for Select
        let isValidHeigherDegree = validate.notEmpty(this.refs.heighestDegree.value);
        isValidHeigherDegree ? this.refs.heighestDegree.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.heighestDegree.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';

        let isValidProfessionalRole = validate.notEmpty(this.refs.professionalRole.value);
        isValidProfessionalRole ? this.refs.professionalRole.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.professionalRole.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';

        let isValidDOBYear = validate.notEmpty(this.refs.dobYear.value);
        isValidDOBYear ? this.refs.dobYear.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.dobYear.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';

        let isValidDOBMonth = validate.notEmpty(this.refs.dobMonth.value);
        isValidDOBMonth ? this.refs.dobMonth.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.dobMonth.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';

        // genderValidation
        //let isValidGender = validate.notEmpty(this.state.gender);
        //isValidGender ? this.refs.gender.className = 'admin-register-button' : this.refs.gender.className = 'admin-register-button error-border';
        let isValidGender = validate.notEmpty(this.refs.gender.value);
        isValidGender ? this.refs.gender.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.gender.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';


        // validation for Select Ethnicity
        let isValidEthnicity = validate.notEmpty(this.refs.ethnicity.value);
        isValidEthnicity ? this.refs.ethnicity.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.ethnicity.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom'

        let isValidOtherEthnicity = null;
        if (this.state.ethnicityId == 7) {
            isValidOtherEthnicity = validate.name(this.refs.otherEthnicity);
            isValidOtherEthnicity ? this.refs.otherEthnicity.className = 'inputText' : this.refs.otherEthnicity.className = 'inputText error';
        }



        if (isValidFName && isValidLName && isValidMobile && isExpectedMobile && isValidEmail && isValidDOBYear && isValidDOBMonth && isValidHeigherDegree && isValidProfessionalRole && isValidGender && isValidEthnicity && (this.state.ethnicityId == 7 ? isValidOtherEthnicity : true)) {
            this.setState({
                firstName: this.refs.firstName.value.trim(),
                lastName: this.refs.lastName.value.trim(),
                mobile: enteredMobile,
                email: this.refs.email.value.trim(),
                dobYear: this.refs.dobYear.value,
                dobMonth: this.refs.dobMonth.value,
                highestDegreeId: this.refs.heighestDegree.value,
                professionalRoleID: this.refs.professionalRole.value,
                gender: this.refs.gender.value,
                ethnicityId: this.refs.ethnicity.value,

                showError: null,
                errorMessage: null,
            })

            if (this.state.ethnicityId == 7) {
                this.setState({ otherEthnicity: this.refs.otherEthnicity.value.trim(), })
            }

            return true;
        } else {
            if (isValidMobile && !isExpectedMobile) {
                this.setState({
                    showError: true,
                    errorMessage: "Entered mobile number should match with registered mobile number."
                });
            }
            else {
                this.setState({
                    showError: true,
                    errorMessage: "Please enter necessary fields to proceed. "
                });
                return false;
            }
        }
    },

    isValideUserEthnicityFacilityDetails() {
        // // Follow the order -- Select Ethnicity, facilityRoleIdValidation, TCValidation, Ethnicity error message show, TC error message show
        // // validation for Select Ethnicity
        // let isValidEthnicity = validate.notEmpty(this.refs.ethnicity.value);
        // isValidEthnicity ? this.refs.ethnicity.parentElement.parentElement.parentElement.className = 'aj-dropdown' : this.refs.ethnicity.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom'

        // let isValidOtherEthnicity = null;
        // if (this.state.ethnicityId == 7) {
        //     isValidOtherEthnicity = validate.name(this.refs.otherEthnicity);
        //     isValidOtherEthnicity ? this.refs.otherEthnicity.className = 'inputText' : this.refs.otherEthnicity.className = 'inputText error';
        // }

        // facilityRoleIdValidation
        let isValidFacilityRoleId = false;
        if (this.state.registrationUrlDetails.roleId === '2') {
            this.state.facilityRoleId != null ? isValidFacilityRoleId = true : isValidFacilityRoleId = false;
            isValidFacilityRoleId ? this.refs.facilityRole.className = 'admin-register-button' : this.refs.facilityRole.className = 'admin-register-button error-border';
            if (isValidFacilityRoleId) {
                this.setState({
                    showError: null,
                    errorMessage: null,
                })
            } else {
                this.setState({
                    showError: true,
                    errorMessage: "Please enter necessary fields to proceed."
                })
                return false;
            }
        }
        return true;
    },

    // TCValidation
    isValidTC() {
        let isValidAgreeTC1 = this.refs.agreeTC1.checked,
            isValidAgreeTC2 = this.refs.agreeTC2.checked,
            isValidAgreeTC3 = this.refs.agreeTC3.checked,
            isValidAgreeTC4 = this.refs.agreeTC4.checked,
            isValidAgreeTC5 = this.refs.agreeTC5.checked,
            isValidAgreeTC6 = this.refs.agreeTC6.checked;
        isValidAgreeTC1 ? this.refs.agreeTC1.parentElement.children[1].className = '' : this.refs.agreeTC1.parentElement.children[1].className = 'error';
        isValidAgreeTC2 ? this.refs.agreeTC2.parentElement.children[1].className = '' : this.refs.agreeTC2.parentElement.children[1].className = 'error';
        isValidAgreeTC2 ? this.refs.agreeTC2.parentElement.children[1].className = '' : this.refs.agreeTC2.parentElement.children[1].firstElementChild.className = 'error';

        isValidAgreeTC3 ? this.refs.agreeTC3.parentElement.children[1].className = '' : this.refs.agreeTC3.parentElement.children[1].className = 'error';
        isValidAgreeTC4 ? this.refs.agreeTC4.parentElement.children[1].className = '' : this.refs.agreeTC4.parentElement.children[1].className = 'error';
        isValidAgreeTC5 ? this.refs.agreeTC5.parentElement.children[1].className = '' : this.refs.agreeTC5.parentElement.children[1].className = 'error';
        isValidAgreeTC6 ? this.refs.agreeTC6.parentElement.children[1].className = '' : this.refs.agreeTC6.parentElement.children[1].className = 'error';
        console.log(this.refs.agreeTC2.parentElement.children[1].firstElementChild, 'children');
        

        // // Ethnicity error message show
        // if (isValidEthnicity && (this.state.ethnicityId == 7 ? isValidOtherEthnicity : true)) {
        //     this.setState({
        //         ethnicityId: this.refs.ethnicity.value,
        //         showError: null,
        //         errorMessage: null,
        //     })

        //     if (this.state.ethnicityId == 7) {
        //         this.setState({ otherEthnicity: this.refs.otherEthnicity.value.trim(), })
        //     }

        // } else {
        //     this.setState({
        //         showError: true,
        //         errorMessage: "Please enter necessary fields to proceed. "
        //     })
        //     return false;
        // }

        // TC error message show
        if (isValidAgreeTC1 && isValidAgreeTC2 && isValidAgreeTC3 && isValidAgreeTC4 && isValidAgreeTC5 && isValidAgreeTC6) {
            this.setState({
                showError: null,
                errorMessage: null,
            })
        } else {
            this.setState({
                showError: true,
                errorMessage: "Please agree to all Terms & Conditions to proceed."
            })
            return false;
        }
        return true;
    },

    facilityRoleSelected(event) {
        event.target.parentElement.className = 'admin-register-button'
        this.setState({ facilityRoleId: parseInt(event.target.value) });
        for (let i = 0; i < event.target.parentElement.children.length; i++) {
            event.target.parentElement.children[i].className = 'white-button'
        }
        event.target.className = 'white-button active'
    },

    isValideUserNamePasswordDetails() {

        let isValidUserName = validate.notEmpty(this.refs.userName.value);
        isValidUserName ? this.refs.userName.className = 'inputText' : this.refs.userName.className = 'inputText error';


        let isValidpassword = validate.isValidPassword(this.refs.password.value.trim());
        isValidpassword ? this.refs.password.className = 'inputText' : this.refs.password.className = 'inputText error';

        let isValidConfirmPassword = validate.isValidPassword(this.refs.confirmPassword.value.trim());
        isValidConfirmPassword ? this.refs.confirmPassword.className = 'inputText' : this.refs.confirmPassword.className = 'inputText error';

        if (!isValidUserName) {
            this.setState({
                showError: true,
                errorMessage: "Please enter necessary fields to proceed."
            });
            return false;
        }

        if (!isValidpassword || !isValidConfirmPassword) {
            this.setState({
                showError: true,
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            });
            return false;
        }

        let isPasswordMatched = false;
        if (this.refs.password.value == this.refs.confirmPassword.value) {
            isPasswordMatched = true;
            this.setState({
                showError: null,
                errorMessage: null,
            });
        } else {
            isPasswordMatched = false;
            this.setState({
                showError: true,
                errorMessage: "Password and verify password should match."
            })
            this.refs.confirmPassword.className = 'inputText error';
            return false;
        }

        if (isValidUserName && isValidpassword && isValidConfirmPassword && isPasswordMatched) {
            this.setState({
                showError: null,
                errorMessage: null,
                userName: this.refs.userName.value.trim(),
                password: this.refs.password.value,
            });

            return true;
        }
    },

    validateUserName() {

        let isValidUserName = validate.notEmpty(this.refs.userName.value);
        isValidUserName ? this.refs.userName.className = 'inputText' : this.refs.userName.className = 'inputText error';
        if (!isValidUserName) {
            this.setState({
                userName: null,
                showError: true,
                errorMessage: "Please enter necessary fields to proceed."
            })
        }
        else {
            this.setState({
                userName: this.refs.userName.value,
                showError: null,
                errorMessage: null,
            })
        }
        return isValidUserName
    },
    validatePassword() {
        let isValidpassword = validate.isValidPassword(this.refs.password.value.trim());

        isValidpassword ? this.refs.password.className = 'inputText' : this.refs.password.className = 'inputText error';
        if (isValidpassword) {
            this.setState({
                password: this.refs.password.value,
                showError: null,
                errorMessage: null,
            })
        } else {
            this.setState({
                password: null,
                showError: true,
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            })
        }
        return isValidpassword;
    },

    validateConfirmPassword() {

        let isValidConfirmpassword = validate.isValidPassword(this.refs.confirmPassword.value.trim());
        isValidConfirmpassword ? this.refs.confirmPassword.className = 'inputText' : this.refs.confirmPassword.className = 'inputText error';
        if (!isValidConfirmpassword) {
            this.setState({
                password: null,
                showError: true,
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            });
            return false;
        }
        if (isValidConfirmpassword && (this.refs.password.value == this.refs.confirmPassword.value)) {
            this.setState({
                password: this.refs.password.value,
                showError: null,
                errorMessage: null,
            })
            return true;
        }
        else {
            this.setState({
                password: null,
                showError: true,
                errorMessage: "Password and verify password should match."
            })
            this.refs.confirmPassword.className = 'inputText error';
            return false;
        }
    },

    closebox() {
        this.setState({ showOkModel: false, oKModelMessage: null });
        if (this.state.isRegistrationLinkExpired || this.props.Settings.profileUpdate && this.props.Settings.profileUpdate.status == 200) {
            this.props.router.push('/');
        }
        // if (this.state.isUpdateRegistrationSuccess) {
        //     this.props.Dispatch(UserActions.user_log_out());
        //     this.props.router.push('/');
        // }
    },

    onDrop(acceptedFiles, rejectedFiles) {
        var uploadedFileName = acceptedFiles[0].name;

        //To check if user upload any file
        if (uploadedFileName) {

            //To check the uploaded file is an image
            var Extension = uploadedFileName.substring(uploadedFileName.lastIndexOf('.') + 1).toLowerCase();
            if (Extension == "png" || Extension == "jpg" || Extension == "jpeg") {

                var size = acceptedFiles[0].size;
                if (size < 2097152) {
                    var imageData = new FormData();

                    imageData.append("file", acceptedFiles[0]);

                    this.props.Dispatch(FacilitiesActions.uploadFacilityImage(imageData));
                    this.setState({
                        updatedProfileImageName: acceptedFiles[0].name,
                        showError: null,
                        errorMessage: null,
                    });
                }
                else {
                    this.setState({ showError: true, errorMessage: "Please select an image that is less than 2MB.", });
                }
            }
            else {
                this.setState({
                    showError: true,
                    errorMessage: 'Only photos with extension .png, .jpg, .jpeg are allowed.',
                })
            }

        }

    },

    onAgreeTC(e) {
        let isValidAgreeTC = this.refs["agreeTC" + e.target.dataset.tc].checked;
        isValidAgreeTC ? this.refs["agreeTC" + e.target.dataset.tc].parentElement.children[1].className = '' : this.refs["agreeTC" + e.target.dataset.tc].parentElement.children[1].className = 'error';
    },

    onEthnicityselectionChanged(event) {
        event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
        this.setState({ ethnicityId: this.refs.ethnicity.value });
        if (event.target.selectedOptions.length > 0 && this.refs.ethnicity.value != 7) {
            this.setState({ otherEthnicity: null });
            this.setState({ ethnicity: event.target.selectedOptions[0].innerText });
        }
    },

    togglePassword() {
        var pwd = document.getElementById("password");
        pwd.type === "password" ? pwd.type = "text" : pwd.type = "password";
    },
    toggleConfirmPassword() {
        var confirmPwd = document.getElementById("confirmPassword");
        confirmPwd.type === "password" ? confirmPwd.type = "text" : confirmPwd.type = "password";
    },

    render() {
        var style = {
            color: 'red'
        }
        let currentDate = new Date();
        let years = [];

        for (let i = currentDate.getFullYear() - 1; i > currentDate.getFullYear() - 101; i--) {
            years.push(i);
        }

        return (
            <div className="vertalign-container">
                <div className="vertalign-child">
                    <h1 className="top-logo">MOBI</h1>
                    {(this.state.selectedTab === 0) &&
                        <div className="admin-login admin-register-fillinfo">
                            <p className="login-head">Hello! First let's get some information about you.</p>
                            {/*<p>We would like to get your personal information.</p>*/}
                            <div className="row">
                                <div className="col-xs-6 padding-left-none">
                                    <div className="input-group">
                                        <input type="text" className="inputText" ref="firstName" defaultValue={this.state.firstName} onFocus={this.remove_error} onBlur={this.no_empty} maxLength="64" tabIndex="1" required />
                                        <span className="floating-label">First Name</span>
                                    </div>
                                    <div className="input-group">
                                        <InputMask type="text" className={this.state.mobileCssClass} defaultValue={this.state.mobile} onFocus={this.remove_error} onBlur={this.phon_validate} ref="mobile" required mask="999 999 9999" maskChar={null} tabIndex="3"></InputMask>
                                        <span className="floating-label">Phone</span>
                                    </div>
                                    <div className="aj-dropdown">
                                        <div className="source">
                                            <div className="question-selection">
                                                <select ref="dobMonth" onChange={this.selectionChanged} onFocus={this.remove_selection_error} onBlur={this.selectionChanged} defaultValue={this.state.dobMonth} tabIndex="5">
                                                    <option value="">Month of Birth</option>
                                                    <option value="1">January</option>
                                                    <option value="2">February</option>
                                                    <option value="3">March</option>
                                                    <option value="4">April</option>
                                                    <option value="5">May</option>
                                                    <option value="6">June</option>
                                                    <option value="7">July</option>
                                                    <option value="8">August</option>
                                                    <option value="9">September</option>
                                                    <option value="10">October</option>
                                                    <option value="11">November</option>
                                                    <option value="12">December</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="aj-dropdown">
                                        <div className="source">
                                            <div className="question-selection">
                                                <select ref="heighestDegree" onChange={this.selectionChanged} onFocus={this.remove_selection_error} onBlur={this.selectionChanged} defaultValue={this.state.highestDegreeId} tabIndex="7">
                                                    <option value="" default>Highest degree completed</option>
                                                    {
                                                        this.state.highestDegrees == null ? '' :
                                                            this.state.highestDegrees.map(function (highestDegrees) {
                                                                return <option key={highestDegrees.id}
                                                                    value={highestDegrees.id}>{highestDegrees.name}</option>;
                                                            })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="aj-dropdown">
                                        <div className="source">
                                            <div className="question-selection">
                                                <select ref="gender" onChange={this.selectionChanged} onFocus={this.remove_selection_error} onBlur={this.selectionChanged} defaultValue={this.state.gender} tabIndex="9">
                                                    <option value="">Biological Sex</option>
                                                    <option value="MALE">Male</option>
                                                    <option value="FEMALE">Female</option>
                                                    <option value="OTHER">Other</option>
                                                    <option value="NA">Don’t want to specify</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-6 padding-right-none">
                                    <div className="input-group">
                                        <input type="text" className="inputText" ref="lastName" defaultValue={this.state.lastName} onFocus={this.remove_error} onBlur={this.no_empty} maxLength="64" tabIndex="2" required />
                                        <span className="floating-label">Last Name</span>
                                    </div>
                                    <div className="input-group readonly">
                                        <input type="text" className="inputText" value={this.state.registrationUrlDetails && this.state.registrationUrlDetails.email ? this.state.registrationUrlDetails.email : ''} onFocus={this.remove_error} onBlur={this.email_validate} ref="email" tabIndex="-1" required />
                                        <span className="floating-label">Email</span>
                                    </div>
                                    <div className="aj-dropdown">
                                        <div className="source">
                                            <div className="question-selection">
                                                <select ref="dobYear" onChange={this.selectionChanged} onFocus={this.remove_selection_error} onBlur={this.selectionChanged} defaultValue={this.state.dobYear} tabIndex="6">
                                                    <option value="" default>Year of Birth</option>
                                                    {
                                                        years.map(function (years) {
                                                            return <option key={years}
                                                                value={years}>{years}</option>;
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="aj-dropdown">
                                        <div className="source">
                                            <div className="question-selection">
                                                <select ref="professionalRole" onChange={this.selectionChanged} onFocus={this.remove_selection_error} onBlur={this.selectionChanged} defaultValue={this.state.professionalRoleID} tabIndex="8">
                                                    <option value="" default>Professional Role</option>
                                                    {
                                                        this.state.professionalRoles == null ? '' :
                                                            this.state.professionalRoles.map(function (professionalRoles) {
                                                                return <option key={professionalRoles.id}
                                                                    value={professionalRoles.id}>{professionalRoles.name}</option>;
                                                            })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="aj-dropdown">
                                        <div className="source">
                                            <div className="question-selection">
                                                <select ref="ethnicity" onChange={this.onEthnicityselectionChanged} onFocus={this.remove_selection_error} onBlur={this.onEthnicityselectionChanged} defaultValue={this.state.ethnicityId} tabIndex="10">
                                                    <option value="" default="">Ethnicity</option>
                                                    {/* <option value="" default="" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum convallis mollis venenatis.">Ethnicity1</option> */}
                                                    {
                                                        this.state.ethnicities == null ? '' :
                                                            this.state.ethnicities.map(function (ethnicities) {
                                                                return <option key={ethnicities.id}
                                                                    value={ethnicities.id} title={ethnicities.description}> {ethnicities.name} </option>;
                                                            })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.ethnicityId == 7 && <div className="input-group">
                                        <input type="text" className="inputText" ref="otherEthnicity" defaultValue={this.state.otherEthnicity} onFocus={this.remove_error} onBlur={this.no_empty} maxLength="64" required tabIndex="11" />
                                        <span className="floating-label">Other Ethnicity</span>
                                    </div>}

                                </div>
                            </div>
                            {/* <p className="register-text">Biological Sex.</p>
                            <div className="admin-register-button" ref="gender">
                                <button className={this.state.gender === "MALE" ? 'white-button active' : 'white-button'} onClick={this.genderSelected} value="MALE">Male</button>
                                <button className={this.state.gender === "FEMALE" ? 'white-button active' : 'white-button'} onClick={this.genderSelected} value="FEMALE">Female</button>
                                <button className={this.state.gender === "OTHER" ? 'white-button active' : 'white-button'} onClick={this.genderSelected} value="OTHER">Others</button>
                                <button className={this.state.gender === "NA" ? 'white-button active' : 'white-button'} onClick={this.genderSelected} value="NA">Don’t want to specify</button>
                            </div> */}



                            <div className="error-message">
                                <span className={this.state.showError ? '' : 'hidden'} style={style}>{this.state.errorMessage} </span>
                            </div>
                            <button className="gray-button fill-button" onClick={this.onTabSubmitted} value='1'>NEXT</button>
                        </div>
                    }
                    {(this.state.selectedTab === 1) &&
                        <div className="admin-login admin-register-role">
                            <span className="icon-backarrow" onClick={this.onBackTabSubmitted} data-backindex='1' ></span>
                            <p className="login-head">Next, upload a profile picture</p>
                            {/*<p>We would like to get some more information about you.</p>*/}
                            {/* <div className="aj-dropdown">
                                <div className="source">
                                    <div className="question-selection">
                                        <select ref="ethnicity" onChange={this.onEthnicityselectionChanged} onFocus={this.remove_selection_error} onBlur={this.onEthnicityselectionChanged} defaultValue={this.state.ethnicityId}>
                                            <option value="" default="">Ethnicity</option>
                                            {
                                                this.state.ethnicities == null ? '' :
                                                    this.state.ethnicities.map(function (ethnicities) {
                                                        return <option key={ethnicities.id}
                                                            value={ethnicities.id}>{ethnicities.name}</option>;
                                                    })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {this.state.ethnicityId == 7 && <div className="input-group">
                                <input type="text" className="inputText" ref="otherEthnicity" defaultValue={this.state.otherEthnicity} onFocus={this.remove_error} onBlur={this.no_empty} maxLength="64" required />
                                <span className="floating-label">Other Ethnicity</span>
                            </div>} */}
                            {(this.state.registrationUrlDetails.roleId === '2') &&
                                <div className="reg-button">
                                    <p className="register-text">Select primary role</p>
                                    <div className="admin-register-button" ref="facilityRole">
                                        <button className={this.state.facilityRoleId === 3 ? 'white-button active' : 'white-button'} onClick={this.facilityRoleSelected} value="3">Psychiatrist</button>
                                        <button className={this.state.facilityRoleId === 4 ? 'white-button active' : 'white-button'} onClick={this.facilityRoleSelected} value="4">Therapist</button>
                                        <button className={this.state.facilityRoleId === 6 ? 'white-button active' : 'white-button'} onClick={this.facilityRoleSelected} value="6">Administrative Staff</button>
                                    </div>
                                </div>
                            }

                            {/*<div className="img-upload">
                                <span className="icon icon-phone"></span>
                                <span className="drag-text"> Drag & Drop your profile pic here<br />
                                    or <a type="file">upload from your computer</a></span>
                            </div>
                            <Dropzone onDrop={this.onDrop} multiple={false} disablePreview={true} className={''} activeClassName='' rejectClassName='' >
                                <p>{this.state.updatedProfileImageName ? this.state.updatedProfileImageName : 'Try dropping some files here, or click to select files to upload.'}</p>
                            </Dropzone>*/}

                            <Dropzone onDrop={this.onDrop} multiple={false} disablePreview={true} className='img-upload' activeClassName='' rejectClassName='' >
                                <span className="icon icon-doctor"></span>
                                <span className="drag-text img-height">{this.state.updatedProfileImageName ? this.state.updatedProfileImageName : 'Drag & Drop your profile pic here  or upload from your computer.'}</span>
                            </Dropzone>
                            {/* <label><input type="checkbox" value="" ref="agreeTC" onClick={this.onAgreeTC} />I agree with Terms and Conditions.</label> */}
                            <div className="error-message">
                                <span className={this.state.showError ? '' : 'hidden'} style={style}>{this.state.errorMessage} </span>
                            </div>
                            <button className="gray-button admin-login-button" onClick={this.onTabSubmitted} value='2' >NEXT</button>
                        </div>
                    }
                    {(this.state.selectedTab === 2) &&
                        <div className="admin-login admin-register admin-login-tndc license-div">
                            <span className="icon-backarrow" onClick={this.onBackTabSubmitted} data-backindex='2' ></span>
                            <p className="login-head">Let's review some terms & conditions.</p>
                            <p className="text-bold">Highlights of the MOBI End User License Agreement</p>
                            <label>The following items are included in the MOBI End User License Agreement that you will be asked to agree to later in the process.  They are summarized here for your convenience.  The actual terms are stated more completely and explicitly in the <a href={`${serviceCallConfig.BASE_URL}/public/terms`} target='_blank'>Safari Health, Inc. MOBI End User License Agreement.</a></label>
                            <label>By clicking “agree” you are acknowledging that you have read the Terms of Agreement and understand the following points: </label>
                            <div className='admin-register-tndc'>
                                <div>
                                    <input type="checkbox" value="" ref="agreeTC1" data-tc='1' onClick={this.onAgreeTC} />
                                    <label> MOBI is a software product and module developed, owned, and distributed by Safari Health, Inc.a Sacramento, California based Health Informatics Company. MOBI is for your use only. You are not allowed to copy, loan, share or give it to anyone else.</label>
                                </div>
                                <div>
                                    <input type="checkbox" value="" ref="agreeTC2" data-tc='2' onClick={this.onAgreeTC} />
                                    <label> <b className={"text-bold"}>MOBI does not provide medical advice</b> and is not for use in medical emergencies.  You cannot contact your physician or care team via this MOBI application.</label>
                                </div>
                                <div>
                                    <input type="checkbox" value="" ref="agreeTC3" data-tc='3' onClick={this.onAgreeTC} />
                                    <label> If you are in need of or are seeking medical treatment or emergency care, you should contact your healthcare provider directly or call 911.</label>
                                </div>
                                <div>
                                    <input type="checkbox" value="" ref="agreeTC4" data-tc='4' onClick={this.onAgreeTC} />
                                    <label> By using MOBI you are agreeing to sharing your complete user data with your care team.  You are also agreeing to sharing your de-identified/anonymized data with Safari Health, Inc.</label>
                                </div>
                                <div>
                                    <input type="checkbox" value="" ref="agreeTC5" data-tc='5' onClick={this.onAgreeTC} />
                                    <label> Safari Health Inc. will own and use your anonymized data for quality improvement and other purposes. You can ask for your data to be removed if you like.  Just contact us at 1-916-669-1160.</label>
                                </div>
                                <div>
                                    <input type="checkbox" value="" ref="agreeTC6" data-tc='6' onClick={this.onAgreeTC} />
                                    <label> The terms in the End User License Agreement may change without notice to you.</label>
                                </div>
                            </div>
                            <div className="error-message">
                                <span className={this.state.showError ? '' : 'hidden'} style={style}>{this.state.errorMessage} </span>
                            </div>
                            <button className="gray-button admin-login-button fill-button" onClick={this.onTabSubmitted} value='3'>I agree with Terms & Conditions</button>
                        </div>
                    }
                    {(this.state.selectedTab === 3) &&
                        <div className="admin-login admin-register license-div">
                            <span className="icon-backarrow" onClick={this.onBackTabSubmitted} data-backindex='3' ></span>
                            <p className="login-head">Create a username & password.</p>
                            {/*<p>Let’s set your username and password</p>*/}
                            <div className="input-group input-field">
                                <input type="text" className="inputText" ref="userName" defaultValue={this.state.userName} onFocus={this.remove_error} onBlur={this.validateUserName} maxLength="64" required />
                                <span className="floating-label">Username</span>
                            </div>
                            <div className="input-group input-field">
                                <input type="password" className="inputText" ref="password" id="password" onFocus={this.remove_error} onBlur={this.validatePassword} maxLength="64" required />
                                <span className="floating-label">Password</span>
                                <img src={require('./../images/eye-open.png')} className='eye-icon' onClick={() => { this.togglePassword() }} />
                            </div>

                            <div className="input-group input-field">
                                <input type="password" className="inputText" ref="confirmPassword" id="confirmPassword" onFocus={this.remove_error} onBlur={this.validateConfirmPassword} maxLength="64" required />
                                <span className="floating-label">re-enter password</span>
                                <img src={require('./../images/eye-open.png')} className='eye-icon' onClick={() => { this.toggleConfirmPassword() }} />
                            </div>
                            <div className="error-message">
                                <span className={this.state.showError ? '' : 'hidden'} style={style}>{this.state.errorMessage} </span>
                            </div>
                            <button className="gray-button admin-login-button" onClick={this.onTabSubmitted} value='4'>REGISTER</button>
                        </div>
                    }
                    <div> {this.state.showOkModel ? <ModalDialogCommon message={this.state.oKModelMessage} action={this.closebox} /> : ""}</div>
                    {this.state.confimationModalMessage && <ModalDialogCommon message={this.state.confimationModalMessage} cancel="true" action2={this.closeConfirmationModal} action={this.onConfirmed} />}
                </div>
            </div>
        );
    }
});
let mapStateToProps = (state) => {

    return {
        RegistrationDetails: state.User,
        Settings: state.Setting,
        FacilitiesDetails: state.Facilites,
        SessionLogoutResponse: state.User.sessionLogoutResponse,
    };
};
let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    SettingActions: bindActionCreators(SettingActions, dispatch),
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Registration));



/** WEBPACK FOOTER **
 ** ./src/screens/registration.js
 **/